export const SCOREBOARD = {
  TENNIS: {
    STAGE_IDS: {
      GAME_STAGE: 34,
    },
    ADVANTAGE_SCORE: 50,
  }
}
